import { useState } from 'react'

const withImageErrorHandling = (WrappedComponent, placeholderImage) => {
  return (props) => {
    const [imageError, setImageError] = useState(false)

    const handleImageError = () => {
      setImageError(true)
    }

    return (
      <WrappedComponent
        {...props}
        imageError={imageError}
        handleImageError={handleImageError}
        placeholderImage={placeholderImage}
      />
    )
  }
}

export default withImageErrorHandling
